import { useYearQuarterNavigation } from 'hooks';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { useTranslation } from 'react-i18next';

import { CapacityResponse } from 'RestAPIs/roster/formation';

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead
} from '@mui/material';

import { NumericTableCell } from 'components/shared/Table';
import TableHeaderRow from 'components/shared/Table/TableHeaderRow';

import { renderPeriodColumnHeaders } from '../util';
import CollapsibleFormationTableRow from './CollapsibleFormationTableRow';
import NetFormationTableRow from './NetFormationTableRow';

interface CapacityTableProps {
  capacity?: CapacityResponse;
}

const CapacityTable = ({ capacity }: CapacityTableProps) => {
  const { t } = useTranslation('common');
  const { isViewPerWeek } = useYearQuarterNavigation();

  return (
    <TableContainer component={Paper}>
      <OverlayScrollbarsComponent style={{ maxWidth: '100%' }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableHeaderRow>
              <TableCell colSpan={7} />
              {renderPeriodColumnHeaders(
                capacity?.grossFormation?.periodHours ?? [],
                isViewPerWeek
              )}
              <NumericTableCell>{t('yearTotal')}</NumericTableCell>
              <NumericTableCell sx={{ width: '62px' }}>%</NumericTableCell>
            </TableHeaderRow>
          </TableHead>
          <TableBody>
            {capacity?.grossFormation && (
              <CollapsibleFormationTableRow
                formation={{
                  ...capacity.grossFormation,
                  employeeFormations: [
                    ...(capacity.grossFormation.employeeFormations || [])
                  ].sort(
                    (a, b) =>
                      Number(a.excludedFromScenario) -
                        Number(b.excludedFromScenario) ||
                      a.employee.name.localeCompare(b.employee.name)
                  )
                }}
                rowName="grossFormation"
              />
            )}
            {capacity?.absenceFormation && (
              <CollapsibleFormationTableRow
                formation={capacity.absenceFormation}
                rowName="absenceFormation"
              />
            )}
            {capacity?.loanFormation?.additionalFormations &&
              capacity.loanFormation.additionalFormations.length > 0 && (
                <CollapsibleFormationTableRow
                  formation={capacity.loanFormation}
                  rowName="loanFormation"
                />
              )}
            {capacity?.netTeamFormation && (
              <NetFormationTableRow
                formation={capacity.netTeamFormation}
                rowName="netTeamFormation"
              />
            )}
            {capacity?.additionalFormation?.additionalFormations &&
              capacity.additionalFormation.additionalFormations.length > 0 && (
                <CollapsibleFormationTableRow
                  formation={capacity.additionalFormation}
                  rowName="additionalFormation"
                />
              )}
            {capacity?.additionalFormation?.additionalFormations &&
              capacity.additionalFormation.additionalFormations.length > 0 &&
              capacity?.netFormation && (
                <NetFormationTableRow
                  formation={capacity.netFormation}
                  rowName="netFormation"
                />
              )}
          </TableBody>
        </Table>
      </OverlayScrollbarsComponent>
    </TableContainer>
  );
};

export default CapacityTable;
